import React, { ReactNode } from "react";
import { useSelector } from "react-redux";

import { IgBadge } from "@intelligems/ig-theme/IgBadge";
import { IgDivider } from "@intelligems/ig-theme/IgDivider";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { ExperienceStatus } from "@intelligems/ig-types/dtos/experiences";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { getProductPickerSelectedProducts } from "@src/store/slices/productPicker";
import { theme } from "@src/theme";

import { SelectedProductList } from "./SelectedProductList";

interface ChosenProductsListProps {
  isView?: boolean;
  experienceStatus?: ExperienceStatus;
  dialogActions?: ReactNode[];
}

export const SelectedProductSection = ({
  dialogActions,
  isView,
  experienceStatus,
}: ChosenProductsListProps) => {
  const products = useSelector(getProductPickerSelectedProducts);
  const theme = useTheme();
  return (
    <Grid
      container
      direction={"column"}
      wrap={"nowrap"}
      sx={{
        // borderLeft: `1px solid ${theme.igBorders.core.default}`,
        paddingTop: "14px",
        height: "365px",
        // height: "450px",
      }}
    >
      <Grid px={7} container direction={"row"} columnSpacing={2}>
        <Grid mr={3}>
          <IgTypography color={theme.palette.text.secondary}>
            Selected
          </IgTypography>
        </Grid>
        <Grid>
          <IgBadge badgeContent={products.length} color={"accent"} />
        </Grid>
      </Grid>
      <Grid px={3}>
        <IgDivider spacing={"s"} />
      </Grid>
      <Grid pl={5}>
        <SelectedProductList
          isView={isView}
          experienceStatus={experienceStatus}
          showToolTipText={false}
        />
      </Grid>
      {/*{dialogActions && (*/}
      {/*  <Box*/}
      {/*    sx={{*/}
      {/*      display: "flex",*/}
      {/*      marginTop: "25px",*/}
      {/*      gap: "10px",*/}
      {/*      justifyContent: "flex-end",*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {dialogActions}*/}
      {/*  </Box>*/}
      {/*)}*/}
    </Grid>
  );
};
